export function documentVisible(): Promise<void> {
  return new Promise(resolve => {
    if (document.visibilityState === 'visible') {
      resolve();
      return;
    }
    document.addEventListener('visibilitychange', () => resolve(), {
      once: true,
      passive: true
    });
  });
}

export function elementVisible(
  element: Element,
  options: IntersectionObserverInit = { threshold: 0.01 }
): Promise<void> {
  return new Promise(resolve => {
    new IntersectionObserver((entries, observer) => {
      for (const { isIntersecting } of entries) {
        if (isIntersecting) {
          observer.disconnect();
          resolve();
        }
      }
    }, options).observe(element);
  });
}
